import React, { useMemo } from 'react';
import StyledNav, { NavButtonGroup } from './Nav.styles';
import NavButton from './NavButton';
import AdminIcon from './AdminIcon';
import { useIsAdmin } from '@innovyze/stylovyze/lib/utils/UserContext';
import { findAltHighlights } from './helpers';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider/useGlobalization';
import { InnovyzeRole, useIsFeatureEnabled, isMinimumRole, } from '@innovyze/stylovyze/lib/utils';
import { RegisteredApplications, STYLOVYZE_FLAGS, } from '@innovyze/stylovyze/lib/types';
import { useConsumeWeaveTheme } from '../../hocs/ApplicationWrapper/theme/WeaveContext';
import { selectApplicationName, useSelectUserContext } from '../../selectors';
import { Subscription } from '@innovyze/shared-utils';
import { useSelector } from 'react-redux';
const AdminButton = ({ altHighlight, }) => {
    const { t } = useGlobalization();
    return (React.createElement(NavButtonGroup, null,
        React.createElement(NavButton, { to: '/admin', dataCy: 'nav-admin', icon: React.createElement(AdminIcon, null), altHighlight: altHighlight }, t('ADMIN', { context: 'Admin button left nav panel' }))));
};
export const Nav = ({ pages }) => {
    const isAdmin = useIsAdmin();
    const { entitlements, innovyzeRole } = useSelectUserContext();
    const applicationName = useSelector(selectApplicationName);
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    const isUserAdminReadOnlyFeatureEnabled = !!useIsFeatureEnabled(STYLOVYZE_FLAGS.USER_READONLY_ADMIN);
    const isFullAccessUser = useMemo(() => entitlements.some(entitlement => entitlement === Subscription.I360AFA ||
        entitlement === Subscription.ASSET_FULL_ACCESS), [entitlements]);
    const isAllowedToSeeAdminButton = isUserAdminReadOnlyFeatureEnabled || isAdmin;
    const backgroundColor = isWeaveTheme && resolvedRoles['colorScheme.surface.level200'];
    const isCurrentlyUsingAssetFullAccess = () => {
        if (applicationName === RegisteredApplications.APP_AM_MAIN) {
            return (isFullAccessUser ||
                isMinimumRole(innovyzeRole, InnovyzeRole.READ_WRITE));
        }
        else {
            return isAllowedToSeeAdminButton;
        }
    };
    return (React.createElement(StyledNav, { backgroundColor: backgroundColor },
        React.createElement(NavButtonGroup, null, pages.map(({ icon, to, title, path, altHighlight, dataCy }, i) => title &&
            icon && (React.createElement(NavButton, { key: i, to: to, icon: icon, path: path, altHighlight: altHighlight, dataCy: dataCy }, title)))),
        isCurrentlyUsingAssetFullAccess() && (React.createElement(AdminButton, { altHighlight: findAltHighlights(pages, '/admin') }))));
};
export default Nav;
